import {combineReducers} from 'redux';

import global, {GlobalState} from './global';
import remittance, {RemittanceState} from './remittance';
import user, {UserState} from './user';
import remittanceResponse, {
  RemittanceResponseState,
} from './remittanceResponse';
import chatRoom, {ChatRoomState} from './chatRoom';
import users, {UsersState} from './users';
import channel, {ChannelState} from './channel';
import registry, {RegistryState} from './registry';

export interface RootState {
  global: GlobalState;
  remittance: RemittanceState;
  user: UserState;
  remittanceResponse: RemittanceResponseState;
  chatRoom: ChatRoomState;
  users: UsersState;
  channel: ChannelState;
  registry: RegistryState;
}

const rootReducer = combineReducers({
  global,
  remittance,
  user,
  remittanceResponse,
  chatRoom,
  users,
  channel,
  registry,
});

export default rootReducer;
